import type { ReactNode } from 'react'

export type MediaPreviewAspect = 'auto' | '16/9' | '4/3'
export type MediaPreviewFit = 'cover' | 'contain'

const ASPECT_CLASS: Record<MediaPreviewAspect, string> = {
	auto: '',
	'16/9': 'aspect-video',
	'4/3': 'aspect-[4/3]',
}

/**
 * Image preview for the rich-text image block and the read-only renderer: a `<figure>` with the
 * picture framed by `aspect` / `fit` and an optional caption. Mirrors what the web renders
 * (`packages/web/src/lib/rich-text.ts`, F0.7) so the editor preview is faithful.
 */
export function MediaPreview({ src, alt, caption, aspect = 'auto', fit = 'cover', width, height }: {
	src: string
	alt?: string | null
	caption?: string | null
	aspect?: MediaPreviewAspect
	fit?: MediaPreviewFit
	width?: number | null
	height?: number | null
}): ReactNode {
	const framed = aspect !== 'auto'
	return (
		<figure className="my-6">
			<div className={['overflow-hidden rounded-xl bg-light-gray', ASPECT_CLASS[aspect]].join(' ')}>
				<img
					src={src}
					alt={alt ?? ''}
					width={width ?? undefined}
					height={height ?? undefined}
					className={framed ? (fit === 'contain' ? 'h-full w-full object-contain' : 'h-full w-full object-cover') : 'block max-w-full h-auto'}
				/>
			</div>
			{caption ? <figcaption className="mt-2 text-sm text-gray">{caption}</figcaption> : null}
		</figure>
	)
}
